<template>
  <v-list
    subheader
    style="height: 400px; overflow: auto;"
    class="custom-scroll"
  >
    <v-subheader>
      <v-layout row>
        Clientes Selecionados
        <v-btn
          v-if="customers.length >= 1"
          text
          @click="removeAll()"
        >
          <v-icon size="20">
            mdi-close
          </v-icon>
          Remover todos
        </v-btn>
      </v-layout>
    </v-subheader>
    <v-list-tile
      v-for="(customer) in customers"
      :key="customer.nomeFantasia"
      color="primary"
      @click="removeCustomer(customer.id)"
    >
      <v-list-tile-content class="text2 secondary300">
        {{ customer.nomeFantasia ? customer.nomeFantasia : customer.id }}
      </v-list-tile-content>
      <v-list-tile-avatar
        size="20"
      >
        <v-icon size="20">
          mdi-close
        </v-icon>
      </v-list-tile-avatar>
    </v-list-tile>
  </v-list>
</template>

<script>
export default {
  name: 'CommunicationSelectedCustomersList',
  props: {
    value: {
      type: Array,
      required: true,
    },
  },
  computed: {
    customers: {
      get() {
        return this.value;
      },
      set(value) {
        this.value = value;
      },
    },
  },
  methods: {
    removeAll() {
      this.$root.$emit('communication-client-remove-all-selected', true);
    },
    removeCustomer(id) {
      const { customers } = this;
      const position = customers.findIndex(
        c => c.id === id,
      );

      if (position > -1) {
        const customer = customers[position];

        this.$root.$emit(
          'communication-client-remove-item-selected',
          customer,
        );

        customers.splice(position, 1);
        this.customers = customers;
      }
    },
  },
};
</script>
